export type FileDownloadStatus = 'NotStarted' | 'Downloading' | 'Complete' | 'Error';
export type FileUploadStatus = 'NotStarted' | 'Uploading' | 'Complete' | 'Error';

/**
 * Utility method to allow caller to automatically set file processing state while running functionality.
 *
 * @param setFileUploadState
 * @param func
 * @constructor
 */
export async function UploadFile(
  setFileUploadState: (value: ((prevState: FileUploadState) => FileUploadState) | FileUploadState) => void,
  func: () => Promise<void>
) {
  setFileUploadState({ status: 'Uploading' });

  await func()
    .then(() => {
      if (!setFileUploadState) {
        return;
      }

      setFileUploadState({ status: 'Complete' });
    })
    .catch((e: Error) => {
      if (!setFileUploadState) {
        return;
      }

      setFileUploadState({ status: 'Error', errorMessage: e.message });
    });

  return;
}

/**
 * Utility method to allow caller to automatically set file processing state while running functionality.
 *
 * @param setFileDownloadState
 * @param func
 * @constructor
 */
export function DownloadFile(
  setFileDownloadState: (
    // value: ((prevState: FileDownloadState) => FileDownloadState) | FileDownloadState
    value: FileDownloadState
  ) => void,
  func: () => Promise<void>
) {
  setFileDownloadState({ status: 'Downloading' });

  func()
    .then(() => {
      if (!setFileDownloadState) {
        return;
      }

      setFileDownloadState({ status: 'Complete' });
    })
    .catch((e: Error) => {
      if (!setFileDownloadState) {
        return;
      }

      setFileDownloadState({ status: 'Error', errorMessage: e.message });
    });

  return;
}

export async function GenerateFileDownload(response: Response) {
  const blob = await response.blob();

  // This code is a bit of a hack to download a fetched result.
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = response.headers.get('Content-Disposition')?.split('filename=')[1].split(';')[0] ?? '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export interface FileDownloadState {
  status: FileDownloadStatus;
  errorMessage?: string;
}

export interface FileUploadState {
  status: FileUploadStatus;
  errorMessage?: string;
}
